import { Link } from 'react-router-dom';

const HeroSection = () => (
  <section className="relative min-h-screen flex items-center overflow-hidden bg-charcoal">
    {/* Background image */}
    <div className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/3730e296102992fee9c616f6a38442bc.jpg"
        alt="Occupational Skills Training Center - Hands-on vocational training in Arlington TX"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-charcoal/95 via-charcoal/80 to-charcoal/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-transparent to-charcoal/30" />
    </div>

    {/* Gold accent */}
    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-transparent via-gold to-transparent opacity-40" />

    {/* Content */}
    <div className="relative z-10 max-w-7xl mx-auto px-6 pt-28 pb-20 w-full">
      <div className="max-w-3xl">
        {/* Pre-label */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-8 h-[2px] bg-gold" />
          <span className="font-inter text-gold text-xs font-semibold tracking-[0.25em] uppercase">
            Arlington, TX — Est. 2012
          </span>
        </div>

        {/* H1 */}
        <h1 className="font-playfair text-4xl md:text-5xl lg:text-[3.5rem] font-bold text-white leading-[1.1] mb-6">
          Build the Skills That Lead to{' '}
          <em className="text-gold not-italic">Real Employment</em>{' '}
          and Lasting Independence
        </h1>

        {/* Subheadline */}
        <p className="font-inter text-base md:text-lg text-white/70 leading-relaxed max-w-2xl mb-6">
          Occupational Skills Training Center equips individuals with vocational training, job readiness, and life skills development — creating a direct pathway from learning to employment.
        </p>

        {/* Proof strip */}
        <div className="flex flex-wrap items-center gap-x-6 gap-y-3 mb-4">
          {[
            { icon: 'ri-user-follow-line', label: '85%+ Job Placement Rate' },
            { icon: 'ri-calendar-check-line', label: '10+ Years Serving DFW' },
            { icon: 'ri-medal-line', label: '500+ Successful Graduates' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-gold text-sm`} />
              </div>
              <span className="font-inter text-sm font-semibold text-white/80">{item.label}</span>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-10">
          {['Vocational certification programs', 'Community-centered approach', 'Employment-focused outcomes'].map((item) => (
            <div key={item} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-gold text-sm" />
              </div>
              <span className="font-inter text-sm text-white/60">{item}</span>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-dark text-charcoal font-inter font-bold text-sm px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Enroll / Get Started
            <i className="ri-arrow-right-line text-base" />
          </Link>
          <a
            href="tel:4698535038"
            className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-gold text-white hover:text-gold font-inter font-semibold text-sm px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line" />
            Call Now: 469-853-5038
          </a>
        </div>
      </div>
    </div>

    {/* Scroll indicator */}
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
      <i className="ri-arrow-down-line text-gold/60 text-lg" />
    </div>
  </section>
);

export default HeroSection;
